enum ProductOptionalFieldNameEnum {
	asset = 'asset',
	careInstruction = 'careInstruction',
	complementaryItem = 'complementaryItem',
	customerMaterial = 'customerMaterial',
	document = 'document',
	filterAttribute = 'filterAttribute',
	genericProduct = 'genericProduct',
	customerBenefitSummary = 'customerBenefitSummary',
	priceInformation = 'priceInformation',
	priceUnit = 'priceUnit',
	child = 'child',
	measureReference = 'measureReference',
	measure = 'measure',
	packageMeasure = 'packageMeasure',
	customerBenefit = 'customerBenefit',
	goodToKnow = 'goodToKnow',
	peopleAndPlanet = 'peopleAndPlanet',
	image = 'image',
	video = 'video',
	technicalInformation = 'technicalInformation',
	complianceTechnical = 'complianceTechnical',
	complianceInformation = 'complianceInformation',
	complianceLabel = 'complianceLabel',
	validDesignPart = 'validDesignPart',
	appConfig = 'appConfig'
}

export default ProductOptionalFieldNameEnum;
